import React from 'react';
export function PrivacyPolicyPage() {
  return <div className="pt-20" data-id="element-359">
      <section className="bg-brand-navy py-24 text-white" data-id="element-360">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-361">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-362">
            Privacy Policy
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-363">
            Your privacy and confidentiality are our top priorities.
          </p>
        </div>
      </section>

      <section className="py-24 bg-white" data-id="element-364">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-365">
          <div className="prose prose-lg text-gray-600 max-w-none" data-id="element-366">
            <h2 className="text-2xl font-bold text-brand-navy mb-4" data-id="element-367">
              1. Commitment to Privacy
            </h2>
            <p className="mb-8" data-id="element-368">
              At Global Restorative Health & Wellness LLC, we are committed to
              protecting the privacy and security of our clients' personal and
              health information. This policy outlines how we collect, use, and
              safeguard your data.
            </p>

            <h2 className="text-2xl font-bold text-brand-navy mb-4" data-id="element-369">
              2. Information Collection
            </h2>
            <p className="mb-8" data-id="element-370">
              We collect information necessary to provide high-quality
              healthcare and mental wellness services. This may include contact
              details, medical history, and insurance information.
            </p>

            <h2 className="text-2xl font-bold text-brand-navy mb-4" data-id="element-371">
              3. Use of Information
            </h2>
            <p className="mb-8" data-id="element-372">
              Your information is used solely for the purpose of providing care,
              coordinating services, and improving our practice. We do not sell
              or share your data with third parties for marketing purposes.
            </p>

            <h2 className="text-2xl font-bold text-brand-navy mb-4" data-id="element-373">
              4. Confidentiality
            </h2>
            <p className="mb-8" data-id="element-374">
              We adhere to strict professional standards and legal requirements
              regarding patient confidentiality. All mental health coaching and
              medical consultations are handled with the utmost discretion.
            </p>

            <h2 className="text-2xl font-bold text-brand-navy mb-4" data-id="element-375">
              5. Contact Us
            </h2>
            <p data-id="element-376">
              If you have any questions about our privacy practices, please
              contact us at info@globalrestorative.com.
            </p>
          </div>
        </div>
      </section>
    </div>;
}